import { useMutation } from "@tanstack/react-query";
import { apiFetch } from "../APIClient";

const KAKAO_API_URL = "/api/payment/kakaopay/ready";

interface PayReadyRequestBody {
  itemName: string;
  totalPrice: number;
  orderId: string;
  userId: string;
}

interface PayReadyResponse {
  next_redirect_pc_url: string;
  // Add other fields from the response if needed
}

const payReady = async (body: PayReadyRequestBody): Promise<PayReadyResponse> => {
  const response = await apiFetch("api/payment/kakaopay/ready", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    throw new Error("결제를 준비하지 못했습니다. 잠시 후 다시 시도해주세요.");
  }

  return response.json();
};

export const usePayReady = () => {
  return useMutation({
    mutationFn: payReady,
    onSuccess: (data) => {
      // Redirect to KakaoPay page on successful API call
      if (data.next_redirect_pc_url) {
        window.location.href = data.next_redirect_pc_url;
      }
    },
    onError: (error) => {
      console.error("Error initiating KakaoPay payment:", error);
      // You can handle the error here, e.g., show a notification
    },
  });
};
